import { Products } from '@/comm'
import { useDatePicker } from '@/components/MyDatePicker'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { formatPercent, formatUSD } from '@/lib/format-utils'
import { getDateRange } from '@/lib/date-utils'

import { Button } from '@/components/ui/button'
import { createColumnVisibilityStore } from '@/components/zthd/data-table'
import { DataTableViewOptions } from '@/components/zthd/data-table-view-options'
import DataTableWithBorder from '@/components/zthd/data-table/data-table-with-border'
import {
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
} from '@tanstack/react-table'
import {
  useColumnFilters,
  VSWeekSelector,
} from '@/components/data-table-selectors'
import { useCountry } from '@/components/DropdownCountry'
import useSWR from 'swr'
import { columnDate, revenueColumn } from './columns'
import { usePid2 } from '@/components/DropdownPid'
import { PID_GROUP } from '@/comm'

const useColumnVisibilityStore = createColumnVisibilityStore({}, 'pcr')

const convertPids = (pids) => {
  return [pids.map((pid) => PID_GROUP[pid]).flat(), pids].flat()
}

const Home = () => {
  const startDate = useDatePicker((state) => state.startDate)
  const endDate = useDatePicker((state) => state.endDate)
  const country = useCountry((state) => state.value)
  const pids = usePid2((state) => state.pids)

  const { columnVisibility, setColumnVisibility } = useColumnVisibilityStore()
  const columnFilters = useColumnFilters((state) => state.columnFilters)

  const { data: revenues, mutate } = useSWR([
    '/revenues/pc',
    { startDate, endDate, country },
  ])

  const data = useMemo(() => {
    const dateRange = getDateRange(dayjs(startDate), dayjs(endDate))
    return dateRange.map((date) => ({ date, revenues: revenues?.[date] }))
  }, [startDate, endDate, revenues])

  const columns = useMemo(() => {
    const ps = Products.filter(
      ({ code }) => !['22', '23'].includes(code),
    ).filter(
      ({ code }) => pids.includes('total') || convertPids(pids).includes(code),
    )
    const rows = [columnDate]
    ps.forEach((p) => {
      const { code, name } = p
      rows.push(revenueColumn(code, name))
    })
    return rows
  }, [pids])

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    enableMultiRowSelection: true,
    state: {
      columnFilters,
      columnVisibility,
    },
  })

  return (
    <>
      <div className="flex items-center xs:gap-1 xs:py-1 sm:gap-2 sm:py-2 gap-4 py-4   flex-wrap">
        <VSWeekSelector />
        <Button variant="outline" onClick={mutate}>
          refresh
        </Button>
        <DataTableViewOptions table={table} />
      </div>
      <DataTableWithBorder table={table} />
    </>
  )
}

export default Home
